import { IonIcon } from "@ionic/react";
import { notifications } from "ionicons/icons";
import React, { useEffect, useState } from "react";
import { Preferences } from "@capacitor/preferences";
import { getIsoDate } from "../../utils/helpers";
export interface HeaderNotificationItem {
  type: string;
  message?: string | number;
  allowClose?: boolean;
  schedule?: {
    time?: string;
  };
  style?: {
    bgColor: string;
    color: string;
    iconColor?: string;
  };
}

interface HeaderNotifyProps {
  existingNotifications?: HeaderNotificationItem[];
  closeAlert: (closed: boolean) => void;
  timeOutDailyReminder: boolean;
}

const HeaderNotify: React.FC<HeaderNotifyProps> = ({
  existingNotifications,
  closeAlert,
  timeOutDailyReminder,
}) => {
  const [fadeOut, setFadeOut] = useState(false);
  const [alreadyClosed, setAlreadyClosed] = useState(true);
  /* -------------------------------
     Fade-out ONLY for DAILY_REMINDER
  -------------------------------- */
  useEffect(() => {
    const checkDismissedAlert = async () => {
      const { value } = await Preferences.get({
        key: "dismissedAlertDate",
      });
      const todayDate = getIsoDate(new Date());
      if (value === todayDate) {
        setAlreadyClosed(true);
      } else {
        setAlreadyClosed(false);
      }
    };
    checkDismissedAlert();
  }, []);
  useEffect(() => {
    if (timeOutDailyReminder) {
      setFadeOut(false);
      const timer = setTimeout(() => setFadeOut(true), 10000);
      return () => clearTimeout(timer);
    }
  }, [timeOutDailyReminder]);
  const closeTodayAlert = () => {
    const today = getIsoDate(new Date());
    Preferences.set({ key: "dismissedAlertDate", value: today });
    closeAlert(true);
    setAlreadyClosed(true);
  };
  return (
    <>
      {existingNotifications?.map((notify, idx) => {
        if (!notify) return null;

        const isDaily = notify.type === "DAILY_REMINDER";
        const isMissed = notify.type === "MISSED_DAYS_ALERT";

        if (isMissed && alreadyClosed) return null;
        if (isDaily && !timeOutDailyReminder) return null;

        return (
          <div
            key={idx}
            style={{
              background: notify.style?.bgColor ?? "#de2a3c",
              color: notify.style?.color ?? "#fff",
              height: "55px",
              borderRadius: "12px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              position: "relative",
              boxShadow: isMissed ? "0 2px 6px rgba(0,0,0,0.08)" : "none",
              opacity: isDaily && fadeOut ? 0 : 1,
              transform:
                isDaily && fadeOut ? "translateY(-20px)" : "translateY(0)",
              transition:
                "opacity 0.5s ease, transform 0.5s ease, max-height 0.5s ease, margin-bottom 0.5s ease, padding 0.5s ease",
              maxHeight: isDaily && fadeOut ? 0 : "55px",
              overflow: "hidden",
              marginBottom: isDaily && fadeOut ? 0 : "8px",
              padding: isDaily && fadeOut ? "0 12px" : "0 12px",
            }}
          >
            {/* Icon + Text */}
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "8px",
                justifyContent: isDaily ? "center" : "flex-start",
                flex: 1,
              }}
            >
              {notify.style?.iconColor && (
                <IonIcon
                  icon={notifications}
                  style={{
                    fontSize: "20px",
                    color: notify.style.iconColor,
                    flexShrink: 0,
                  }}
                />
              )}

              <span
                style={{
                  fontSize: isDaily ? "20px" : "15px",
                  color: notify.style?.color,
                  marginRight: "10px",
                }}
              >
                {notify.message}
              </span>
            </div>

            {/* Close button */}
            {notify.allowClose && (
              <button
                aria-label="Close"
                onClick={closeTodayAlert}
                style={{
                  position: "absolute",
                  top: "6px",
                  right: "8px",
                  background: "transparent",
                  border: "none",
                  fontSize: "22px",
                  cursor: "pointer",
                  color: "#888",
                  lineHeight: 1,
                }}
              >
                &times;
              </button>
            )}
          </div>
        );
      })}
    </>
  );
};

export default HeaderNotify;
